const messages = {
  title: "Hjem",
  welcomeMessage:
    'Velkommen til BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Hjem",
  search: "Søg efter",
  sortBy: "Sorter efter",
  seeMore: "Se mere",
  bankstatement: {
    yourScore: "Dit nuværende antal marketingpoint:",
    lastUpdate: "Seneste opdatering:",
    link: "Point balance oversigt",
  },
  shop: {
    bestSold: "Bedst sælgende",
    seasonal: "Sæsonbestemt",
    affordable: "Prisvenligt",
    forPoints: "for {points} point",
    reachedPoints: "Det nødvendige antal point er nået",
    cartRemainPoints: "Resterende point",
    remainingPoints: "{points} point mangler",
    noProducts: "Ingen produkter fundet",
    variant: "Varianter kan vælges",
  },
  showAllProducts: "Gå til shoppen",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>er snart tilgængelig igen.</div>",
};
export default {
  messages,
};
